import { Routes } from '@angular/router';
import { authGuard } from '@core/guard/auth/auth.guard';
import { permissionsGuard } from '@core/guard/permissions/permissions.guard';
import { ClientAuthLayoutComponent } from './layout/client/components/client-auth-layout/client-auth-layout.component';
import { ClientLayoutComponent } from './layout/client/components/client-layout/client-layout.component';
import { AuthLayout } from './layout/components/app.authlayout';
import { LayoutComponent } from './layout/components/layout/layout.component';
import { clientSetupResolver } from './layout/service/client-setup/client-setup.resolver';
import { HomeComponent } from '@modules/home/pages/home/home.component';
import { PageNotFoundComponent } from '@modules/home/pages/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: LayoutComponent,
        canActivate: [authGuard],
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            component: HomeComponent,
            data: { breadcrumb: 'Inicio' },
          },
          {
            path: 'statistics',
            loadChildren: () => import('./modules/home/home.routes').then((r) => r.homeRoutes),
            data: { breadcrumb: 'Estadísticas' },
          },
          {
            path: 'shipments',
            loadChildren: () =>
              import('./modules/shipments/shipments.routes').then((r) => r.shipmentsRoutes),
            data: { breadcrumb: 'Envíos' },
          },
          {
            path: 'users',
            loadChildren: () => import('./modules/users/users.routes').then((r) => r.usersRoutes),
            data: { breadcrumb: 'Usuarios' },
          },
          {
            path: 'roles',
            loadChildren: () => import('./modules/users/roles.routes').then((r) => r.rolesRoutes),
            data: { breadcrumb: 'Roles' },
          },
          {
            path: 'client-default-roles',
            loadChildren: () =>
              import('./modules/client-default-roles/client-default-roles.routes').then(
                (r) => r.clientDefaultRolesRoutes,
              ),
            data: { breadcrumb: 'Roles clientes' },
          },
          {
            path: 'clients',
            loadChildren: () =>
              import('./modules/clients/clients.routes').then((r) => r.clientsRoutes),
            data: { breadcrumb: 'Clientes' },
          },
          {
            path: 'contacts',
            loadChildren: () =>
              import('./modules/contacts/contacts.routes').then((r) => r.ContactsRoutes),
            data: { breadcrumb: 'Contactos' },
          },
          {
            path: 'form-submissions',
            loadChildren: () =>
              import('./modules/form-submissions/form-submissions.routes').then(
                (r) => r.formSubmissionsRoutes,
              ),
            data: { breadcrumb: 'Formularios' },
            canActivate: [permissionsGuard],
          },
          {
            path: 'demo',
            loadChildren: () => import('./modules/demo/demo.routes').then((r) => r.demoRoutes),
            data: { breadcrumb: 'Demos' },
            canActivate: [permissionsGuard],
          },
          {
            path: 'configurations',
            loadChildren: () =>
              import('./modules/configurations/configurations.routes').then(
                (r) => r.configurationsRoutes,
              ),
            data: { breadcrumb: 'Configuraciones' },
          },
          // TODO: eliminar en un futuro config
          {
            path: 'config',
            loadChildren: () =>
              import('./modules/config/config.routes').then((r) => r.configRoutes),
            data: { breadcrumb: 'Configuración' },
          },
          {
            path: 'settings',
            loadChildren: () =>
              import('./modules/settings/settings.routes').then((r) => r.SettingsRoutes),
            data: { breadcrumb: 'Ajustes' },
          },
          {
            path: 'tools',
            loadChildren: () => import('./modules/tools/tools.routes').then((r) => r.toolsRoutes),
            data: { breadcrumb: 'Herramientas' },
          },
          {
            path: 'utils',
            loadChildren: () => import('./modules/utils/utils.routes').then((r) => r.utilsRoutes),
            data: { breadcrumb: 'Utilidades' },
          },
          {
            path: 'audits',
            loadChildren: () => import('./modules/audit/audit.routes').then((r) => r.auditRoutes),
            data: { breadcrumb: 'Auditorias' },
          },
          {
            path: 'ratings',
            loadChildren: () =>
              import('./modules/ratings/ratings.routes').then((r) => r.ratingsRoutes),
            data: { breadcrumb: 'Valoraciones' },
            canActivate: [permissionsGuard],
          },
          {
            path: 'user',
            loadChildren: () => import('./modules/user/user.routes').then((r) => r.userRoutes),
            data: { breadcrumb: 'Usuario' },
            title: 'Usuarios',
          },
          {
            path: 'teams',
            loadChildren: () =>
              import('./modules/users/pages/teams/teams.routes').then((r) => r.teamsRoutes),
            data: { breadcrumb: 'Equipos D2D' },
            title: 'Equipos D2D',
          },
          {
            path: 'developer',
            loadChildren: () =>
              import('./modules/developer/developer.routes').then((r) => r.developerRoutes),
            data: { breadcrumb: 'Developer' },
            canActivate: [permissionsGuard],
          },
          {
            path: 'impersonate',
            loadChildren: () =>
              import('./modules/impersonation/impersonation.routes').then(
                (r) => r.impersonationRoutes,
              ),
            data: { breadcrumb: 'Impersonar usuario' },
          },
          {
            path: 'page-not-found',
            component: PageNotFoundComponent,
          },
        ],
      },
      {
        path: 'privacy-policies',
        loadComponent: () =>
          import('./modules/policies/pages/privacy/privacy.component').then(
            (c) => c.PrivacyComponent,
          ),
        title: 'Política de Privacidad',
      },
      // Layout for unauthenticated routes
      {
        path: 'auth',
        component: AuthLayout,
        loadChildren: () =>
          import('./modules/authentication/auth.routes').then((r) => r.authRoutes),
      },
    ],
  },
  {
    path: ':client',
    resolve: { user: clientSetupResolver },
    children: [
      {
        path: '',
        component: ClientLayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            component: HomeComponent,
            data: { breadcrumb: 'Inicio' },
          },
          {
            path: 'statistics',
            loadChildren: () => import('./modules/home/home.routes').then((r) => r.homeRoutes),
            data: { breadcrumb: 'Estadísticas' },
          },
          {
            path: 'shipments',
            loadChildren: () =>
              import('./modules/shipments/shipments.routes').then((r) => r.shipmentsRoutes),
            data: { breadcrumb: 'Envíos' },
          },
          {
            path: 'users',
            loadChildren: () => import('./modules/users/users.routes').then((r) => r.usersRoutes),
            data: { breadcrumb: 'Usuarios' },
          },
          {
            path: 'roles',
            loadChildren: () => import('./modules/users/roles.routes').then((r) => r.rolesRoutes),
            data: { breadcrumb: 'Roles' },
          },
        ],
      },
      // Layout for unauthenticated routes
      {
        path: 'auth',
        component: ClientAuthLayoutComponent,
        loadChildren: () =>
          import('./modules/authentication/auth.routes').then((r) => r.authRoutes),
      },
    ],
  },
  {
    path: 'public/contracts',
    loadChildren: () =>
      import('./modules/public/contracts/public-contracts.routes').then(
        (r) => r.publicContractsRoutes,
      ),
    title: 'Contratos',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'page-not-found',
  },
];
